module.exports = __webpack_public_path__ + "static/media/18.ed70a452.png";